import React, { useContext } from 'react';
import { Message } from 'talkplus-sdk/dist/model/types';
import Text from '@common/text';
import Reaction from '@components/chat/chatDetail/messageList/reaction';
import { ReactionProps, ReactionStateType } from '@components/chat/hooks/useChatReactionState';
import { ChatContext, ChatContextType } from '@components/chat/ChatContext';
import { ReactionType } from '@domain/constant/chat/ReactionType';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface ReactionBtnProps {
  type: ReactionType;
  count: number;
  isActive: boolean;
  onClick: () => void;
}

const ReactionBtn = ({ type, count, isActive, onClick }: ReactionBtnProps) => {
  const isText = count > 1;

  if (count === 0) return null;

  return (
    <button className={cx('emojiBtn', { active: isActive })} onClick={onClick}>
      <Reaction type={type} width={16} height={16} />
      {isText && <Text className={cx('text')}>{count}</Text>}
    </button>
  );
};

// 채팅에서 받은 리액션
interface ReactionListProps {
  positionType?: 'left' | 'right' | undefined;
  message: Message;
  reactionsState: ReactionStateType;
  addReactionState: ({ reaction, callback }: { callback: () => void } & ReactionProps) => void;
  removeReactionState: ({ reaction, callback }: { callback: () => void } & ReactionProps) => void;
}

const ReactionList = ({
  positionType = 'left',
  message,
  reactionsState,
  addReactionState,
  removeReactionState,
}: ReactionListProps) => {
  const { addMessageReaction, removeMessageReaction } = useContext<ChatContextType>(ChatContext);

  const handleAddReaction = ({ reaction }: ReactionProps) => {
    addReactionState({
      reaction,
      callback: async () => {
        // 미리 선택했던 리액션에서 내가 선택한 리액션을 모두 삭제
        for await (const { isActive, type } of reactionsState) {
          isActive && (await removeMessageReaction({ message, reaction: type }));
        }

        // 내가 선택한 리액션 추가
        await addMessageReaction({ message, reaction });
      },
    });
  };

  const handleRemoveReaction = ({ reaction }: ReactionProps) => {
    removeReactionState({
      reaction,
      callback: () => removeMessageReaction({ message, reaction }),
    });
  };

  const emojiEls = reactionsState.map(({ type, count, isActive }) => {
    const handleClick = () => {
      isActive ? handleRemoveReaction({ reaction: type }) : handleAddReaction({ reaction: type });
    };

    return <ReactionBtn key={type} type={type} count={count} isActive={isActive} onClick={handleClick} />;
  });

  return <div className={cx('emojiListArea', positionType)}>{emojiEls}</div>;
};

export default ReactionList;
